import axios from 'axios';

// Función de prueba para verificar conectividad
const testAPI = async () => {
  try {
    console.log('🔄 Probando conexión con Laravel...');
    
    // Probar endpoint básico
    const response = await axios.get('http://localhost:8000/api/auth/login', {
      timeout: 5000
    });
    console.log('✅ API respondió:', response.status);
    return true;
  } catch (error) {
    console.log('❌ Error de conexión:', error.message);
    
    if (error.code === 'ECONNREFUSED') {
      console.log('🚨 El servidor Laravel no está corriendo en puerto 8000');
      console.log('💡 Ejecuta: php artisan serve');
    } else if (error.response?.status === 404) {
      console.log('🚨 Ruta /api no encontrada');
      console.log('💡 Verifica que las rutas estén configuradas en routes/api.php');
    } else {
      console.log('🚨 Error:', error.response?.status, error.response?.statusText);
    }
    return false;
  }
};

// Función para probar rutas específicas
const testRoutes = async () => {
  const routes = [
    '/api',
    '/api/login', 
    '/api/register'
  ];
  
  for (const route of routes) {
    try {
      const response = await axios.get(`http://localhost:8000${route}`, {
        timeout: 3000
      });
      console.log(`✅ ${route}: ${response.status}`);
    } catch (error) {
      if (error.response?.status === 405) {
        console.log(`⚠️  ${route}: Método no permitido (normal para POST routes)`);
      } else if (error.response?.status === 404) {
        console.log(`❌ ${route}: No encontrada (404)`);
      } else {
        console.log(`❌ ${route}: Error ${error.response?.status || error.code}`);
      }
    }
  }
};

export { testAPI, testRoutes };
